import { supabase } from '@/lib/supabase';

// 진도 단원을 '완료' 상태로 표시해요. (수업일지에서 끝낸 단원 연동 시 사용)
export async function markProgressDone(ids: string[]): Promise<void> {
  const unique = Array.from(new Set(ids.filter(Boolean)));
  if (unique.length === 0) return;
  const { error } = await supabase
    .from('progress_items')
    .update({ status: 'done' })
    .in('id', unique);
  if (error) throw error;
}

// 진도 단원을 다시 '예정' 상태로 되돌려요. (연동 취소·수업일지 삭제 시 사용)
export async function markProgressPlanned(ids: string[]): Promise<void> {
  const unique = Array.from(new Set(ids.filter(Boolean)));
  if (unique.length === 0) return;
  const { error } = await supabase
    .from('progress_items')
    .update({ status: 'planned' })
    .in('id', unique);
  if (error) throw error;
}

// 진도 항목 목록에서 달성률을 계산해요.
export function progressPercent(items: { status: string }[]): number {
  if (items.length === 0) return 0;
  const done = items.filter((i) => i.status === 'done').length;
  return Math.round((done / items.length) * 100);
}